/**
 * Firebase configuration matching Flutter firebase_options.dart
 */
export const firebaseConfig = {
  apiKey: 'AIzaSyBprLtfVfwZP5mJE64b8fE9p-KFnwMFVD0',
  appId: '1:415351845257:web:37c91ceab4275badf6f158',
  messagingSenderId: '415351845257',
  projectId: 'expause-com',
  authDomain: 'expause-com.firebaseapp.com',
  storageBucket: 'expause-com.appspot.com',
  measurementId: 'G-06FCN61K4B',
};

export type FirebaseConfig = typeof firebaseConfig;
